import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, Twitter, Youtube } from 'lucide-react';
export function ContactInfo() {
  const contactMethods = [{
    icon: MapPin,
    label: 'Visit Us',
    value: '13460 Baltimore Ave, Laurel, MD 20707',
    link: 'https://maps.google.com/?q=13460+Baltimore+Ave+Laurel+MD+20707'
  }, {
    icon: Phone,
    label: 'Call Us',
    value: '(301) 555-0100',
    link: 'tel:+13015550100'
  }, {
    icon: Mail,
    label: 'Email Us',
    value: 'info@houseofflavors.com',
    link: 'mailto:info@houseofflavors.com'
  }];
  const businessHours = [{
    day: 'Monday - Thursday',
    hours: '5:00 PM - 2:00 AM'
  }, {
    day: 'Friday - Saturday',
    hours: '5:00 PM - 4:00 AM'
  }, {
    day: 'Sunday',
    hours: '5:00 PM - 12:00 AM'
  }];
  const departments = [{
    name: 'VIP & Bottle Service',
    email: 'vip@houseofflavors.com',
    phone: '(301) 555-0101'
  }, {
    name: 'Private Events',
    email: 'events@houseofflavors.com',
    phone: '(301) 555-0102'
  }, {
    name: 'Corporate Inquiries',
    email: 'corporate@houseofflavors.com',
    phone: '(301) 555-0103'
  }];
  const socialLinks = [{
    icon: Instagram,
    href: '#',
    label: 'Instagram'
  }, {
    icon: Facebook,
    href: '#',
    label: 'Facebook'
  }, {
    icon: Twitter,
    href: '#',
    label: 'Twitter'
  }, {
    icon: Youtube,
    href: '#',
    label: 'YouTube'
  }];
  return <div className="space-y-8" data-id="element-164">
      {/* Contact Methods */}
      <div className="space-y-4" data-id="element-165">
        {contactMethods.map((method, index) => <motion.a key={method.label} href={method.link} target={method.icon === MapPin ? '_blank' : undefined} rel={method.icon === MapPin ? 'noopener noreferrer' : undefined} initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: index * 0.1
      }} className="flex items-start gap-4 p-5 bg-[#1A2228] border border-white/10 rounded-xl hover:border-[#DDA247] transition-all group" data-id="element-166">
            <div className="w-12 h-12 bg-[#DDA247]/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#DDA247]/20 transition-colors" data-id="element-167">
              <method.icon className="w-5 h-5 text-[#DDA247]" data-id="element-168" />
            </div>
            <div data-id="element-169">
              <p className="text-xs text-gray-500 uppercase tracking-widest mb-1" data-id="element-170">
                {method.label}
              </p>
              <p className="text-white font-medium group-hover:text-[#DDA247] transition-colors" data-id="element-171">
                {method.value}
              </p>
            </div>
          </motion.a>)}
      </div>

      {/* Business Hours */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3
    }} className="bg-gradient-to-br from-[#1A2228] to-[#0F161B] border border-white/10 rounded-xl p-6" data-id="element-172">
        <div className="flex items-center gap-3 mb-6" data-id="element-173">
          <div className="w-10 h-10 bg-[#DDA247]/10 rounded-lg flex items-center justify-center" data-id="element-174">
            <Clock className="w-5 h-5 text-[#DDA247]" data-id="element-175" />
          </div>
          <h3 className="text-lg font-bold text-white uppercase tracking-wide" data-id="element-176">
            Business Hours
          </h3>
        </div>
        <div className="space-y-3" data-id="element-177">
          {businessHours.map((schedule, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-white/5 last:border-0" data-id="element-178">
              <span className="text-sm text-gray-400" data-id="element-179">{schedule.day}</span>
              <span className="text-sm text-white font-medium" data-id="element-180">
                {schedule.hours}
              </span>
            </div>)}
        </div>
      </motion.div>

      {/* Departments */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.4
    }} className="bg-gradient-to-br from-[#1A2228] to-[#0F161B] border border-white/10 rounded-xl p-6" data-id="element-181">
        <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-182">
          Direct Departments
        </h3>
        <div className="space-y-4" data-id="element-183">
          {departments.map((dept, index) => <div key={index} className="pb-4 border-b border-white/5 last:border-0 last:pb-0" data-id="element-184">
              <p className="text-white font-medium mb-2" data-id="element-185">{dept.name}</p>
              <div className="space-y-1" data-id="element-186">
                <a href={`mailto:${dept.email}`} className="text-xs text-gray-400 hover:text-[#DDA247] transition-colors block" data-id="element-187">
                  {dept.email}
                </a>
                <a href={`tel:${dept.phone.replace(/[^0-9]/g, '')}`} className="text-xs text-gray-400 hover:text-[#DDA247] transition-colors block" data-id="element-188">
                  {dept.phone}
                </a>
              </div>
            </div>)}
        </div>
      </motion.div>

      {/* Social Media */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} className="bg-gradient-to-br from-[#1A2228] to-[#0F161B] border border-white/10 rounded-xl p-6" data-id="element-189">
        <h3 className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-190">
          Follow Us
        </h3>
        <div className="flex gap-3" data-id="element-191">
          {socialLinks.map((social, index) => <motion.a key={social.label} href={social.href} whileHover={{
          scale: 1.1,
          y: -2
        }} whileTap={{
          scale: 0.95
        }} className="w-12 h-12 bg-[#DDA247]/10 rounded-lg flex items-center justify-center hover:bg-[#DDA247] hover:text-[#0B1014] text-[#DDA247] transition-all" aria-label={social.label} data-id="element-192">
              <social.icon className="w-5 h-5" data-id="element-193" />
            </motion.a>)}
        </div>
      </motion.div>

      {/* Map Placeholder */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6
    }} className="relative h-64 bg-[#1A2228] border border-white/10 rounded-xl overflow-hidden group cursor-pointer" onClick={() => window.open('https://maps.google.com/?q=13460+Baltimore+Ave+Laurel+MD+20707', '_blank')} data-id="element-194">
        <div className="absolute inset-0 bg-gradient-to-br from-[#DDA247]/20 to-transparent opacity-50" data-id="element-195" />
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-196">
          <div className="text-center" data-id="element-197">
            <MapPin className="w-12 h-12 text-[#DDA247] mx-auto mb-3" data-id="element-198" />
            <p className="text-white font-bold mb-1" data-id="element-199">View on Google Maps</p>
            <p className="text-sm text-gray-400" data-id="element-200">
              13460 Baltimore Ave, Laurel, MD
            </p>
          </div>
        </div>
        <div className="absolute inset-0 bg-[#DDA247]/0 group-hover:bg-[#DDA247]/10 transition-colors" data-id="element-201" />
      </motion.div>
    </div>;
}